import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpeakhm855: FaireProductEntity = {
  token: "p_tpeakhm855",
  type: "product",
  name: "BOAT NECK BUTTON FRONT LONG SLEEVE TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/de6c2e767fc7edd9811724945b9afe1bef4786b365059625f7c611f26631bb6a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1968aab5b3dd5f622f7fe3b96afc9ecf6a16107f1e7d3dc62a50ec5a89d8180d.jpeg",
    "https://cdn.faire.com/fastly/6ab22bc26444cee37a510db2e9b7e0a3d9097bbd5a06daf96e81156ff5c182fd.jpeg",
    "https://cdn.faire.com/fastly/e2e9742fb997156704dfbb336d5bc5909de59e18c65437264cd5d746fc036c5f.jpeg",
    "https://cdn.faire.com/fastly/dede9cc64e42ca9be1036a3343937d4c59eded285500db3bd8a22e4e0d30d5d2.jpeg",
    "https://cdn.faire.com/fastly/0fa1470522b83f5bd15f908cac4b40a339d16f811e6f02e6229d9b8bd9a80235.jpeg",
  ],
  priceDollars: 174,
  description:
    '**TOP ONLY**\n\n(MATCHING SET WITH: SP3925)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'10"\nBUST: 33B\nWAIST: 23.5"\nHIPS: 35"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:07.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
